export default function Dining() {
  return (
    <section id="dining" className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/demo/hotel-site/images/dining.png"
          alt="Dining Experience"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>
      <div className="relative z-10 h-full flex items-center justify-center px-8">
        <div className="max-w-3xl text-center text-white">
          <p className="text-sm tracking-widest uppercase mb-6">美食の粋</p>
          <h3 className="text-5xl md:text-6xl font-serif mb-8 leading-tight">
            味覚が記憶になる、特別な食卓
          </h3>
          <p className="text-lg leading-relaxed mb-8 text-white/90">
            ミシュランの星を持つ懐石料理「杜若」、世界の美酒が揃う「スカイバー 蒼穹」。厳選された食材と匠の技が織りなす、忘れられない美食体験をお約束いたします。
          </p>
          <button className="px-10 py-4 bg-white text-gray-900 text-sm tracking-widest whitespace-nowrap hover:bg-gray-100 transition-colors">
            お食事を見る
          </button>
        </div>
      </div>
    </section>
  );
}